import $ from '../jquery-shim.js';

export function triggerMiniCart() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('open-minicart')) {
    $('body').trigger('added_to_cart');
  }
}
